import { Component } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { BrandLogoComponent } from '../../shared/brand-logo/brand-logo.component';
import { VdButtonComponent } from '../../ui/button/button.component';

@Component({
  selector: 'app-page404',
  standalone: true,
  imports: [CommonModule, RouterModule, BrandLogoComponent, VdButtonComponent],
  templateUrl: './page404.component.html',
  styleUrls: ['./page404.component.css'],
})
export class Page404Component {
  constructor(
    private location: Location,
    private router: Router,
  ) {}

  goBack(): void {
    if (history.length > 1) this.location.back();
    else this.router.navigateByUrl('/Accueil');
  }

  goHome(): void {
    this.router.navigateByUrl('/Accueil');
  }
}
